import { baseApi } from "@/config/http-common";

class RoleDataService {
  getAll(params: any): Promise<any> {
    return baseApi.get("/common/roles/list", { params: params });
  }

  get(id: any): Promise<any> {
    return baseApi.get(`/common/roles/view/${id}`);
  }

  create(data: any): Promise<any> {
    return baseApi.post("/common/roles/create", data);
  }

  update(id: any, data: any): Promise<any> {
    return baseApi.put(`/common/roles/update/${id}`, data);
  }

  delete(id: string): Promise<any> {
    return baseApi.delete(`/common/roles/delete/${id}`);
  }
}

export default new RoleDataService();
